import React from "react";
import styled from "styled-components";
import Navbar from "./Navbar";
import Statistic from "./Statistic";
import Invoice from "../pages/Sales/InvoiceList";
import Sales from "./Sales";
import Orders from "./Orders";
import Analytic from "./Analytic";
import Shopping from "./Shopping";
import Add from "./Add";
import CustomerList from "../pages/Customers/CustomerList";
import EmployeeList from "../pages/Employees/EmployeeList";
import ProductList from "../pages/Product/ProductList";
import GunList from "../pages/Guns/GunList";
import Inventory from "../pages/Inventory/InventoryList.js";
import Repair  from "../pages/Repairs/Repairs";
import ReportList  from "../pages/Reports/ReportList";
import Message  from "../pages/Message/MessageList";

function Dashboard({ currentPage }) {
    return (
        <Section>
            {/* ✅ Pass currentPage as a prop to update navbar title */}
            <Navbar className="navbar" pageTitle={currentPage} />

            <div className="content">
                {currentPage === "Dashboard" && (
                    <div className="grid">
                        <div className="grid_1">
                            <Statistic />
                            <Sales />
                            <Orders />
                        </div>
                        <div className="grid_2">
                            <Analytic />
                            <Shopping />
                            <Add />
                        </div>
                    </div>
                )}
                {currentPage === "Invoice" && <Invoice />}
                {currentPage === "Inventory" && <Inventory />}
                {currentPage === "Repair" && <Repair />}
                {/* ✅ Products Submenu */}
                {currentPage === "Products" && <ProductList />}
                {currentPage === "AllProducts" && <ProductList />}
                {currentPage === "Guns" && <GunList />}

                {currentPage === "Employees" && <EmployeeList />}
                {currentPage === "Customers" && (
                    <div>
                        <CustomerList />
                    </div>
                )}
                {currentPage === "Reports" && (
                    <div>
                        <ReportList />
                    </div>
                )}
                {currentPage === "Message" && <Message/>}

            </div>
        </Section>
    );
}

export default Dashboard;

const Section = styled.section`
    display: flex;
    flex-direction: column;
    margin-left: 18vw; /* Ensures sidebar space */
    padding: 2rem;
    height: 100%;

    .content {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
    }
    

    .grid {
        display: grid;
        grid-template-columns: 70% 28%;
        gap: 2rem;
        margin-top: 2rem;

        .grid_1, .grid_2 {
            display: flex;
            flex-direction: column;
            gap: 1rem;
        }
    }
    .navbar {
        position: fixed;
        top: 0;
        left: 0;
        width: 18vw;
        height: 100vh;
        background: black;
        color: white;
        padding: 20px;
        z-index: 2000; /* ✅ Increased for visibility */
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
    }
`;
